"use client";

import React from "react";
import { Star, Check, Phone, ArrowRight, Loader, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const SHARED_DATA = {
  businessName: "Mike Dillard",
  phone: "512-555-0123",
  rating: "4.9/5.0",
  reviewCount: "1,200+",
  benefits: ["Build a Powerful Personal Brand", "Scale Your Business to 7-Figures", "Master Modern Wealth Strategies", "Join an Elite Global Community"]
};
function QuoteFormInternal() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="12374" className="flex flex-col items-center justify-center py-10 text-center space-y-4 animate-in fade-in zoom-in duration-500">
        <div className="size-16 rounded-full bg-primary/10 flex items-center justify-center">
          <Check className="size-8 text-primary" />
        </div>
        <h3 className="text-xl font-bold text-foreground">{successMessage}</h3>
        <p className="text-muted-foreground">We will be in touch shortly to discuss your growth strategy.</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4">
      <FormField control={control} name="name" rules={{
      required: "Name is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Full Name</FormLabel>
            <FormControl>
              <Input placeholder="Jane Smith" {...field} className="bg-background border-border shadow-sm focus:ring-primary rounded-xl" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="phone" rules={{
      required: "Contact number is required",
      pattern: {
        value: /^[0-9\s\-\+\(\)]*$/,
        message: "Invalid phone number"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Phone Number</FormLabel>
            <FormControl>
              <Input type="tel" placeholder="+1 (555) 000-0000" {...field} className="bg-background border-border shadow-sm focus:ring-primary rounded-xl" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="service_type" rules={{
      required: "Please select an area of focus"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Area of Interest</FormLabel>
            <FormControl>
              <div className="relative">
                <select className={cn("flex h-9 w-full items-center justify-between rounded-xl border border-input bg-background px-3 py-1 text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary disabled:cursor-not-allowed disabled:opacity-50", !field.value && "text-muted-foreground")} {...field}>
                  <option value="" disabled>Select a path</option>
                  <option value="Personal Branding">Personal Branding</option>
                  <option value="Business Scaling">Business Scaling</option>
                  <option value="Wealth Management">Wealth Management</option>
                  <option value="Podcast Mentorship">Podcast Mentorship</option>
                </select>
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="address" render={({
      field
    }) => <FormItem>
            <FormLabel>Website or LinkedIn URL</FormLabel>
            <FormControl>
              <Input placeholder="https://linkedin.com/in/username" {...field} className="bg-background border-border shadow-sm focus:ring-primary rounded-xl" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="details" render={({
      field
    }) => <FormItem>
            <FormLabel>Tell me about your goals</FormLabel>
            <FormControl>
              <textarea className="flex min-h-[80px] w-full rounded-xl border border-input bg-background px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50" placeholder="What is the biggest challenge you're facing right now?" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-3 text-sm text-destructive bg-destructive/10 rounded-xl border border-destructive/20">
          {submitError}
        </div>}

      <Button type="submit" className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-bold py-6 text-lg shadow-lg rounded-xl" disabled={isSubmitting}>
        {isSubmitting ? <>
            <Loader className="mr-2 size-5 animate-spin" />
            Processing...
          </> : <>
            Apply for Consultation <ArrowRight className="ml-2 size-5" />
          </>}
      </Button>
      
      <p className="text-xs text-center text-muted-foreground mt-2">
        We review applications daily and will respond within 24-48 hours.
      </p>
    </Form>;
}
export default function QuickQuoteForm() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return;
}